module.exports = __webpack_public_path__ + "static/media/no-jobs-dashboard-employer.8c508bac.svg";